import Vue from 'vue'
import Router from 'vue-router'
import appRouter from './router'
import Cookies from 'js-cookie'

Vue.use(Router)

// 路由配置
const RouterConfig = {
    //mode: 'history',
    routes: appRouter
};

const router = new Router(RouterConfig);

//路由的全局前置守卫 to:即将要进去的路由目标 from 当前到离开的路由目标
router.beforeEach((to, from, next) => {
    if (!Cookies.get('access') && to.name == 'detail') {
        next({
            name: 'login'
        });
    } else if (!Cookies.get('access') && to.name == 'atlasdetail') {
        next({
            name: 'login'
        });
    } else if (!Cookies.get('access') && to.name == 'previewdetail') {
        next({
            name: 'login'
        });
    } else if (!Cookies.get('access') && to.name == 'previewatlas') {
        next({
            name: 'login'
        });
    } else if (!Cookies.get('access') && to.name == 'upload') {
        next({
            name: 'login'
        });
    } else if (!Cookies.get('access') && to.name == 'updateatlas') {
        next({
            name: 'login'
        });
    } else if (!Cookies.get('access') && to.name == 'updatedetail') {
        next({
            name: 'login'
        });
    } else if (!Cookies.get('access') && to.name == 'personcard') {
        next({
            name: 'login'
        });
    } else if (!Cookies.get('access') && to.name == 'verifcopyr') {
        next({
            name: 'login'
        });
    } else {    
        next() //进行管道中的下一个钩子 next(false):中断当前的导航
               //next({ path: '/' })跳到一个不同的地址
    }
})
//路由的全局后置钩子
router.afterEach((to, from) => {
    // ...
    window.scrollTo(0, 0);
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js